import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from 'components/Common/Button'
import Dialog from '@mui/material/Dialog'
import ConnectButton from 'components/Common/Button/ConnectButton/index'
import Overlay from 'components/Common/Overlay'
import ToolTip from 'components/Common/ToolTip'
import SectionTitle from 'components/Common/SectionTitle'
import ButtonTooltip from 'components/Common/ToolTip/ButtonTooltip'

import { Timeline } from 'react-twitter-widgets'

import TextField from 'components/Common/TextField'

import { SECONDARY_BUTTON, DISABLED_BUTTON } from 'themes/theme'
import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots'

import linkOffSvg from 'assets/link-off.svg'

const Card = styled(Box)(() => ({
  padding: '25px',
  minHeight: '650px',
  height: '80vh',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

const CardHeader = styled(Box)(() => ({
  width: '100%',
  height: '30px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '20px',
}))

const DialogContent = styled(Box)(({ theme }) => ({
  width: '350px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '30px',
}))

const DialogActionBar = styled(Box)(() => ({
  width: '100%',
  gap: '2rem',
  marginTop: '2rem',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

function TwitterLiveFeed(props) {
  const [twitterId, setTwitterId] = useState(localStorage.getItem('twitterId') ? localStorage.getItem('twitterId') : '')
  const [newTwitterId, setNewTwitterId] = useState('')
  const [visibleDialog, setVisibleDialog] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false)
  const [showSpinner, setSpinner] = useState(true)

  const userInfo = useSelector(state => state.userReducer.user)

  const onChange = event => {
    setNewTwitterId(event.target.value)
  }

  const onConnect = () => {
    setSpinner(true)
    localStorage.setItem('twitterId', newTwitterId)
    setTwitterId(newTwitterId)
    setVisibleDialog(false)
  }

  const onDisconnect = () => {
    localStorage.setItem('twitterId', '')
    setTwitterId('')
  }

  const toggleDialog = () => {
    setNewTwitterId(twitterId)
    setVisibleDialog(!visibleDialog)
  }

  const tooltipContent = (
    <Typography variant="body2" color="white">
      Quick view of recent posts from your linked social media platform.
    </Typography>
  )

  return (
    <Card onMouseOver={() => setShowOverlay(true)} onMouseLeave={() => setShowOverlay(false)}>
      <CardHeader>
        <Box>
          <SectionTitle title="Twitter Feed" />
          &nbsp;
          <ToolTip content={tooltipContent} />
        </Box>
        <Box sx={{ display: 'flex' }}>
          {!!twitterId && (
            <ButtonTooltip placement={'top'} title={'Disconnect App'} arrow onClick={onDisconnect}>
              <img
                src={linkOffSvg}
                height="20px"
                width="20px"
                alt={'twitter-disconnect-button'}
                style={{ cursor: 'pointer' }}
              />
            </ButtonTooltip>
          )}
        </Box>
      </CardHeader>
      {!!showOverlay && userInfo?.accountType === 'free' && (
        <Overlay>
          <Box
            sx={{
              height: 'calc(100% - 100px)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-around',
            }}
          >
            <Typography
              component="div"
              variant="body1B"
              color="white"
              sx={{
                width: '70%',
                textAlign: 'center',
                marginBottom: 2,
              }}
            >
              Social media is as much about community-building as it is trends. Keep track of your social media
              profile’s live feed in this tile so you stay in the loop by connecting your accounts.
            </Typography>
          </Box>
        </Overlay>
      )}
      <Box
        sx={{
          // display: 'flex',
          alignItems: 'center',
          height: '520px',
          width: '100%',
          overflowY: 'auto',
        }}
      >
        {!twitterId.length ? (
          <img
            width="100%"
            height="100%"
            src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/06302022/TwitterTile.svg'}
            alt="twitter-placeholder"
          />
        ) : (
          <>
            {showSpinner && <Box display="flex" alignItems="center" justifyContent="center" height='100%'>
              <ThreeDotsLoadingSpinner width="60px" />
            </Box>}
            <Timeline
              dataSource={{
                sourceType: 'profile',
                screenName: twitterId,
              }}
              options={{
                width: '100%',
                height: '520px',
              }}
              onLoad={() => setSpinner(false)}
              renderError={error => {
                console.error(error)
                return (
                  <Typography component="p" color="primary" variant="body1">
                    Twitter account <em>@{twitterId}</em> not found.
                  </Typography>
                )
              }}
            />
          </>
        )}
      </Box>

      <ConnectButton
        onClick={toggleDialog}
        label={`Connect ${!!twitterId.length ? 'Different' : 'Your'} Twitter Account`}
        fullWidth={true}
      />

      {!!visibleDialog && (
        <Dialog
          open={visibleDialog}
          onClose={toggleDialog}
          aria-labelledby="google-connect-dialog-title"
          aria-describedby="google-connect-dialog-description"
        >
          <DialogContent>
            <CloseIcon
              onClick={toggleDialog}
              fontSize="medium"
              sx={{
                cursor: 'pointer',
                position: 'absolute',
                top: '30px',
                right: '30px',
              }}
            />
            <Typography variant="h6" sx={{ textAlign: 'center', maxWidth: 'calc(100% - 60px)' }}>
              Input Twitter Id
            </Typography>
            <Box component="div" variant="body1" sx={{ width: '100%', fontSize: '14px' }}>
              {/* <Label editorId={twitterId}>Twitter @</Label> */}
              <TextField
                fullWidth
                bgwhite
                id="twitterId"
                label="Twitter @"
                maxLength={'15'}
                style={{ fontSize: '16px' }}
                onChange={onChange}
                value={newTwitterId}
                placeholder=""
              />
              {/* <Input id="twitterId" maxLength={'15'} style={{fontSize:'16px'}} onChange={onChange} value={newTwitterId} placeholder="" /> */}
            </Box>
            <DialogActionBar>
              <Button fullWidth negative onClick={toggleDialog} aria-label="closeTwitterConnectDialog">
                Close
              </Button>
              <Button
                fullWidth
                onClick={onConnect}
                aria-label="twitterConnectButton"
                type={!!newTwitterId ? SECONDARY_BUTTON : DISABLED_BUTTON}
              >
                Connect
              </Button>
            </DialogActionBar>
          </DialogContent>
        </Dialog>
      )}
    </Card>
  )
}

export default TwitterLiveFeed
